
import { useState } from 'react';
import Hero from './components/Hero';
import EventOverview from './components/EventOverview';
import Participation from './components/Participation';
import Prizes from './components/Prizes';
import EventDetails from './components/EventDetails';
import Footer from './components/Footer';
import SubmitEntryModal from './components/SubmitEntryModal';
import SnowEffect from '../../components/feature/SnowEffect';

export default function Home() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <SnowEffect />
      <Hero />
      <EventOverview />
      <Participation onSubmitClick={() => setIsModalOpen(true)} />
      <Prizes />
      <EventDetails />
      <Footer />
      <SubmitEntryModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
}
